import styled from "styled-components"
import {media} from '../../../util';
import {COLOR, SIZE} from "../../../const"

export const Wrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > * {
    margin: 20px 0;
  }
`
export const Title = styled.div`
  font-weight: bold;
  font-size: ${SIZE.font_xlarge};
`
export const ProgressWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`
export const Progress = styled.div<{active?: boolean}>`
  padding: 10px 15px;
  border: 1px solid ${COLOR.main};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  font-size: ${SIZE.font_medium};
  color: ${(props) => (props.active ? "white" : COLOR.header)};
  background-color: ${(props) => (props.active ? COLOR.main : "white")};
`
export const ProgressArrow = styled.div`
  color: ${COLOR.header};
  padding: 10px 10px;
`
export const Desc = styled.div`
  text-align: center;
  font-size: ${SIZE.font_medium};
`
export const FormWrapper = styled.div`
  ${media.pc`width: 80%;`}
  & > * {
    margin-bottom: 30px;
  }
`
export const Button = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 10px;
  padding: 10px 20px;
  background-color: ${COLOR.header};
  color: white;
  cursor: pointer;
`
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 50%;
`
